import { useTranslation } from '@klv/hooks/useTranslation';

import { generateClassName } from '@klv/shared/utils/functions';
import TranslatedDate from '@klv/atoms/translated-date';
import Buttons from '@klv/molecules/buttons';
import BlogCategoryButton from '@klv/molecules/blog-category-button';

import BlogHeroAuthorThumbnail from './blog-hero-author-thumbnail';
import * as styles from './styles/blogArticleHero.module.scss';
import type { IBlogArticleHero } from './types';

const BlogArticleHero = ({
  authors,
  cardImage,
  category,
  className,
  date,
  description = '',
  displayAuthorDate,
  headline,
  readTime,
  titleCtas,
  ...props
}: IBlogArticleHero) => {

  const { t } = useTranslation();
  
  return (
    <div className={generateClassName(['grid', className, styles.blogArticleHero])} {...props}>
      <div className={generateClassName([styles.textContainer, (cardImage ? '' : styles.noImage)])}>
        <div className={styles.headlineContainer}>
        <h1 className={generateClassName(['h2', 'semiBold'])}>
          {headline}
        </h1>
        {titleCtas?.buttons && titleCtas.buttons.length > 0 && (
          <div className={styles.buttonsContainer}>
            <Buttons 
              buttons={titleCtas.buttons}
              buttonColor='dark'
              variants={['primary', 'secondary']}
            />
          </div>
        )}
        {description && (
          <p 
            className={generateClassName(['p1', styles.description])}
            dangerouslySetInnerHTML={{ __html: description }}
          />
        )}
        </div>
        <div className={generateClassName([styles.infoContainer, (cardImage ? '' : styles.noImageInfo)])}>
          {displayAuthorDate  &&  authors && 
            <BlogHeroAuthorThumbnail
              cardImageExists={cardImage ? true : false}
              authors={authors}
              readTime={readTime}
            />
          }
          {category && (
            <BlogCategoryButton
              className={styles.blogCategoryButton}
              afterText={displayAuthorDate && <TranslatedDate date={date} options={{
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              }}/>}
              link={category.link}
              name={category.name}
            />
          )}
        </div>
      </div>

    {cardImage && cardImage?.srcSet && (
      <div className={styles.heroImage}>
        <img
          alt={cardImage.altText || `${t('organisms_blogArticleHero_featureImageAltText')}`}
          loading='eager'
          sizes='(max-width: 1023px) 100vw, (max-width: 1199px) 544px, (max-width: 1365px) 611px, 588px'
          src={cardImage.sourceUrl}
          srcSet={cardImage.srcSet}
        />
      </div>
    )}
  </div>
  );
};

export default BlogArticleHero;
